module.exports = __webpack_public_path__ + "static/media/36-14.80756973.mp3";